import next29_step_1 from "./29_next_step_1.png"
import next29_step_2 from "./29_next_step_2.png"
import next29_step_3 from "./29_next_step_3.png"
import next29_step_4 from "./29_next_step_4.png"
import next29_step_5 from "./29_next_step_5.png"
import next29_step_6 from "./29_next_step_6.png"
import next29_step_7 from "./29_next_step_7.png"
import next29_step_8 from "./29_next_step_8.png"
import next29_step_9 from "./29_next_step_9.png"
import account_manager from "./account_manager.png"
import adyen_step_1 from "./adyen_step_1.gif"
import adyen_step_3 from "./adyen_step_3.png"
import adyen_step_4 from "./adyen_step_4.png"
import adyen_step_5 from "./adyen_step_5.png"
import integration_adyen from "./adyen.svg"
import chatgpt_dark from "./ai-tools/chatgpt_dark.svg"
import chatgpt from "./ai-tools/chatgpt.png"
import claude from "./ai-tools/claude.png"
import gemini from "./ai-tools/gemini.png"
import grok_dark from "./ai-tools/grok_dark.svg"
import grok from "./ai-tools/grok.png"
import meta from "./ai-tools/meta.png"
import perplexity from "./ai-tools/perplexity.png"
import airwallex_step_1 from "./airwallex_step_1.webp"
import airwallex_step_2 from "./airwallex_step_2.webp"
import airwallex_step_3 from "./airwallex_step_3.webp"
import airwallex_step_4 from "./airwallex_step_4.webp"
import airwallex_step_5 from "./airwallex_step_5.webp"
import airwallex_step_6 from "./airwallex_step_6.webp"
import airwallex_step_7 from "./airwallex_step_7.webp"
import airwallex_step_8 from "./airwallex_step_8.webp"
import airwallex_step_9 from "./airwallex_step_9.webp"
import integration_airwallex from "./airwallex.svg"
import amex_dark from "./americanexpress_dark.svg"
import amex from "./americanexpress.svg"
import apple from "./apple.svg"
import authorize_step_1 from "./authorize_step_1.png"
import authorize_step_2 from "./authorize_step_2.png"
import authorize_step_3 from "./authorize_step_3.png"
import authorize_step_4 from "./authorize_step_4.png"
import bank_of_america_dark from "./bank_of_america_dark.svg"
import bank_of_america from "./bank_of_america.svg"
import bank_of_canada_dark from "./bank_of_canada_dark.svg"
import bank_of_canada from "./bank_of_canada.svg"
import bank_of_montreal_dark from "./bank_of_montreal_dark.svg"
import bank_of_montreal from "./bank_of_montreal.svg"
import bank from "./bank.svg"
import bogus from "./bogus.png"
import braintree_step_1 from "./braintree_step_1.webp"
import braintree_step_2 from "./braintree_step_2.webp"
import braintree_step_3 from "./braintree_step_3.webp"
import braintree from "./braintree.svg"
import cartes_bancaires from "./cartes_bancaires.png"
import charge_by from "./charge_by.svg"
import chargebee_step_1 from "./chargebee_step_1.webp"
import chargebee_step_2 from "./chargebee_step_2.webp"
import chargebee_step_3 from "./chargebee_step_3.webp"
import chargebee_step_4 from "./chargebee_step_4.webp"
import chargebee_step_5 from "./chargebee_step_5.webp"
import code_lines from "./code-lines.svg"
import cup from "./cup.svg"
import alerts_overview_dark from "./dashboard/alerts_overview_dark.svg"
import alerts_overview from "./dashboard/alerts_overview.svg"
import emptyAS_dark from "./dashboard/emptyAS_dark.png"
import emptyAS from "./dashboard/emptyAS.png"
import mastercard_logo_dark from "./dashboard/mastercard_logo_dark.png"
import mastercard_logo from "./dashboard/mastercard_logo.png"
import verifi_logo_dark from "./dashboard/verifi_logo_dark.png"
import verifi_logo from "./dashboard/verifi_logo.png"
import ds from "./diners-club.svg"
import discover from "./discover.svg"
import discover_dark from "./discover.svg"
import eftpos from "./eftpos.svg"
import emailConfirmed from "./emailConfirmed.svg"
import enrollment_mastercard_dark from "./enrollment_mastercard_dark.svg"
import enrollment_mastercard from "./enrollment_mastercard.svg"
import enrollment_visa_dark from "./enrollment_visa_dark.svg"
import enrollment_visa from "./enrollment_visa.svg"
import fdtre from "./fdtre.png"
import feedback_modal_bg from "./feedback_modal_bg.jpg"
import google from "./google.svg"
import bh_historical_data_banner from "./health/bh_historical_data_banner.svg"
import switcher_shopify from "./health/data-source-switcher/switcher_shopify.png"
import switcher_stripe from "./health/data-source-switcher/switcher_stripe.png"
import no_data from "./health/no_data.svg"
import shopify_connect_banner from "./health/shopify-connect-banner.png"
import stripe_connect_banner from "./health/stripe-connect-banner.png"
import info from "./info.svg"
import integration_authorize from "./integration_authorize.svg"
import integration_braintree from "./integration_braintree.png"
import integration_chargebee from "./integration_chargebee.svg"
import integration_chatgpt from "./integration_chatgpt.svg"
import integration_claude from "./integration_claude.svg"
import integration_custom_mcp from "./integration_custom_mcp.svg"
import integration_klarna from "./integration_klarna.svg"
import integration_manual_refunds from "./integration_manual_refunds.svg"
import integration_maverick from "./integration_maverick.svg"
import integration_missing from "./integration_missing.svg"
import integration_mollie from "./integration_mollie.svg"
import integration_nmi from "./integration_nmi.svg"
import integration_paypal from "./integration_paypal.svg"
import integration_recharge from "./integration_recharge.svg"
import integration_recurly from "./integration_recurly.svg"
import integration_shopify from "./integration_shopify.svg"
import integration_stripe from "./integration_stripe.svg"
import integration_zapier from "./integration_zapier.svg"
import interac from "./interac.png"
import jcb from "./jcb.svg"
import link from "./link.svg"
import logoWithTextAdminWhite from "./logo_with_text_admin_white.svg"
import logoWithTextAdmin from "./logo_with_text_admin.svg"
import logoWithTextWhite from "./logo_with_text_white.svg"
import logoWithText from "./logo_with_text.svg"
import logo from "./logo.svg"
import maestro from "./maestro.svg"
import mastercard_3d from "./mastercard_3d.png"
import mastercard_gray from "./mastercard_gray.svg"
import mastercard_icon from "./mastercard_icon.svg"
import mastercard from "./mastercard.svg"
import maverick_step_1 from "./maverick_step_1.webp"
import maverick_step_2 from "./maverick_step_2.gif"
import maverick_step_3 from "./maverick_step_3.webp"
import maverick_step_4 from "./maverick_step_4.webp"
import integration_next from "./next_commerce.svg"
import nmi_step_1 from "./nmi_step_1.png"
import nmi_step_2 from "./nmi_step_2.png"
import nmi_step_3 from "./nmi_step_3.png"
import no_data_available_webhooks_dark from "./no_data_available_webhooks_dark.svg"
import no_data_available_webhooks from "./no_data_available_webhooks.svg"
import other_card from "./other_card.svg"
import payment_paypal from "./payment_paypal.svg"
import payment_shopify from "./payment_shopify.svg"
import payment_stripe from "./payment_stripe.svg"
import paypal_step_1 from "./paypal_step_1.png"
import paypal_step_2 from "./paypal_step_2.png"
import paypal_step_3 from "./paypal_step_3.png"
import paypal_step_4 from "./paypal_step_4.png"
import paypal_step_5 from "./paypal_step_5.png"
import paypal from "./paypal.svg"
import photo_placeholder from "./photo_placeholder.svg"
import rdrPopUpFirstImage from "./rdrPopUpFirstImage.png"
import rdrPopUpSecondImage from "./rdrPopUpSecondImage.png"
import recurly_step_1 from "./recurly_step_1.webp"
import recurly_step_2 from "./recurly_step_2.webp"
import recurly_step_3 from "./recurly_step_3.webp"
import referral_ethoca from "./referral-ethoca.svg"
import referral_verifi from "./referral-verifi.svg"
import shopify from "./shopify.svg"
import slack_bg from "./slack_bg.png"
import clack_step_1 from "./slack_step_1.png"
import clack_step_2 from "./slack_step_2.png"
import integration_slack from "./slack.svg"
import facebook from "./social-media/facebook.png"
import instagram from "./social-media/Instagram.png"
import linkedin from "./social-media/linkedin.png"
import tiktok from "./social-media/tiktok.png"
import x_dark from "./social-media/x_dark.svg"
import x from "./social-media/x.png"
import youtube from "./social-media/youtube.png"
import stripe_charged from "./stripe_charged.svg"
import stripe from "./stripe.svg"
import aol from "./toAol.svg"
import gmail from "./toGmail.svg"
import gmx from "./toGMX.svg"
import hey from "./toHey.svg"
import icloud from "./toICloud.svg"
import outlook from "./toOutlook.svg"
import protonmail from "./toProtonmail.svg"
import yahoo from "./toYahoo.svg"
import yandex from "./toYandex.svg"
import zoho from "./toZoho.svg"
import adyen_transaction from "./transaction-instruction/adyen_transaction.png"
import airwallex_transaction from "./transaction-instruction/airwallex_transaction.png"
import authorize_net_classic_transaction from "./transaction-instruction/authorize.net_classic_transaction.png"
import authorize_net_new_transaction from "./transaction-instruction/authorize.net_new_transaction.png"
import braintree_transaction from "./transaction-instruction/braintree_transaction.png"
import chargebee_transaction from "./transaction-instruction/chargebee_transaction.png"
import next_commerce_transaction from "./transaction-instruction/next_commerce_transaction.png"
import nmi_transaction from "./transaction-instruction/nmi_transaction.png"
import recurly_transaction from "./transaction-instruction/recurly_transaction.png"
import shopify_find_transaction_link from "./transaction-instruction/shopify-find_transaction_link.gif"
import stripe_find_transaction_link from "./transaction-instruction/stripe-find_transaction_link.gif"
import unionpay from "./unionpay.svg"
import integration_premium_support_dark from "./user-added_dark.svg"
import integration_premium_support from "./user-added.svg"
import verifi_dark from "./verifi_dark.svg"
import verifi_gray from "./verifi_gray.svg"
import verifi from "./verifi.svg"
import visa_3d from "./visa_3d.png"
import visa_logo from "./visa_logo.svg"
import visa from "./visa.svg"

const Images = {
  logo,
  logoWithText,
  logoWithTextWhite,
  logoWithTextAdmin,
  logoWithTextAdminWhite,

  shopify,
  stripe,
  paypal,
  braintree,
  bank,

  payment_shopify,
  payment_stripe,
  payment_paypal,
  payment_braintree: braintree,

  integration_braintree,
  integration_klarna,
  integration_missing,
  integration_mollie,
  integration_paypal,
  integration_shopify,
  integration_stripe,
  integration_stripe_dev: integration_stripe,
  integration_chargebee,
  integration_recurly,
  integration_manual_refunds,
  integration_slack,
  integration_next,
  integration_full: integration_slack,
  integration_premium_support,
  integration_premium_support_dark,
  "integration_authorize.net": integration_authorize,
  integration_nmi,
  integration_airwallex,
  integration_adyen,
  integration_maverick,
  integration_claude,
  integration_chatgpt,
  integration_recharge,
  integration_custom_mcp,
  integration_zapier,

  enrollment_visa,
  enrollment_visa_dark,
  enrollment_mastercard,
  enrollment_mastercard_dark,
  bank_of_montreal,
  bank_of_montreal_dark,

  visa,
  visa_dark: enrollment_visa_dark,
  mastercard,
  mastercard_gray,
  mastercard_dark: enrollment_mastercard_dark,
  "japan credit bureau": jcb,
  "diners club international": ds,
  jcb: jcb,
  unionpay,
  eftpos,
  amex,
  amex_dark,
  "american express": amex,
  "american express_dark": amex_dark,
  discover,
  discover_dark,
  other: other_card,
  bank_of_america,
  bank_of_america_dark,
  bank_of_canada,
  bank_of_canada_dark,
  link,

  ethoca: mastercard,
  rdr: verifi,
  cdrn: verifi,

  verifi,
  verifi_dark,
  verifi_gray,

  google,
  apple,
  emailConfirmed,

  gmail,
  outlook,
  yahoo,
  protonmail,
  aol,
  zoho,
  icloud,
  gmx,
  hey,
  yandex,

  braintree_step_1,
  braintree_step_2,
  braintree_step_3,

  chargebee_step_1,
  chargebee_step_2,
  chargebee_step_3,
  chargebee_step_4,
  chargebee_step_5,

  paypal_step_1,
  paypal_step_2,
  paypal_step_3,
  paypal_step_4,
  paypal_step_5,

  recurly_step_1,
  recurly_step_2,
  recurly_step_3,

  clack_step_1,
  clack_step_2,

  authorize_step_1,
  authorize_step_2,
  authorize_step_3,
  authorize_step_4,

  nmi_step_1,
  nmi_step_2,
  nmi_step_3,

  next29_step_1,
  next29_step_2,
  next29_step_3,
  next29_step_4,
  next29_step_5,
  next29_step_6,
  next29_step_7,
  next29_step_8,
  next29_step_9,

  airwallex_step_1,
  airwallex_step_2,
  airwallex_step_3,
  airwallex_step_4,
  airwallex_step_5,
  airwallex_step_6,
  airwallex_step_7,
  airwallex_step_8,
  airwallex_step_9,

  adyen_transaction,
  airwallex_transaction,
  authorize_net_classic_transaction,
  authorize_net_new_transaction,
  braintree_transaction,
  chargebee_transaction,
  next_commerce_transaction,
  nmi_transaction,
  recurly_transaction,
  shopify_find_transaction_link,
  stripe_find_transaction_link,

  alerts_overview,
  alerts_overview_dark,
  no_data_available_webhooks,
  no_data_available_webhooks_dark,
  mastercard_logo,
  mastercard_icon,
  visa_logo,
  mastercard_logo_dark,
  verifi_logo,
  verifi_logo_dark,
  emptyAS,
  emptyAS_dark,

  slack_bg,
  stripe_charged,
  charge_by,

  rdrPopUpFirstImage,
  rdrPopUpSecondImage,
  feedback_modal_bg,
  account_manager,
  referral_ethoca,
  referral_verifi,
  code_lines,

  instagram,
  facebook,
  linkedin,
  tiktok,
  x,
  x_dark,
  youtube,

  chatgpt,
  chatgpt_dark,
  claude,
  gemini,
  grok,
  grok_dark,
  meta,
  perplexity,

  cup,

  visa_3d,
  mastercard_3d,
  adyen_step_1,
  adyen_step_3,
  adyen_step_4,
  adyen_step_5,
  maestro,

  bogus,
  cartes_bancaires,
  fdtre,
  interac,

  maverick_step_1,
  maverick_step_2,
  maverick_step_3,
  maverick_step_4,

  stripe_connect_banner,
  shopify_connect_banner,
  no_data,

  switcher_shopify,
  switcher_stripe,
  bh_historical_data_banner,
  photo_placeholder,
  info
}

export default Images
